/* ============================================================================
   Sixth Man - keep the browser chrome in step with the drawers.

   THE PROBLEM
   On iOS the strip behind the clock/signal and Safari's bottom bar are painted
   by the BROWSER, not the page. Safari tints them from the `theme-color` meta
   tag and re-evaluates when the page's colour near those edges changes. So
   opening the orange drawer went: panel slides in -> Safari notices -> chrome
   flips a beat later. No CSS on the drawer could fix that, because the chrome
   is not the page.

   THE FIX
   Drive `theme-color` ourselves, timed against the slide.

   TUNING - THE ONLY NUMBER WORTH TOUCHING IS `LEAD_MS`
   The panel slides in 180ms (sm-drawer-motion.css). Safari animates the chrome
   recolour on its OWN, shorter curve, which the page cannot set or read. So
   switching the meta tag on the first frame of the open made the chrome ARRIVE
   FIRST and wait for the panel.

   `LEAD_MS` holds the tint back so the two land together. Raise it if the
   chrome still leads; lower it if the chrome now trails.

   Applied symmetrically: on close the panel takes the same 180ms to leave, so
   the tint should return on the same delay rather than snapping grey while an
   orange panel is still on screen.

   A pending change is always cancelled before a new one is scheduled - opening
   and closing quickly must not leave a stale colour behind.
   ============================================================================ */
(function () {
  "use strict";

  var GREY = "#F3F3F3";
  var BRAND = "#CB5727";
  var LEAD_MS = 110;   // hold the tint back so it lands with the 180ms slide

  var meta = document.querySelector('meta[name="theme-color"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.setAttribute("name", "theme-color");
    document.head.appendChild(meta);
  }

  var drawers = [
    document.querySelector(".sidebar-container"),
    document.querySelector("[data-cart-drawer]")
  ].filter(Boolean);

  if (!drawers.length) return;

  function fromStore() {
    try {
      if (window.Alpine && typeof Alpine.store === "function") {
        var s = Alpine.store("drawer");
        if (s && ("menuDrawerOpen" in s || "cartDrawerOpen" in s)) {
          return !!(s.menuDrawerOpen || s.cartDrawerOpen);
        }
      }
    } catch (e) {}
    return null;
  }

  function anyOpen() {
    var s = fromStore();
    if (s !== null) return s;
    return drawers.some(function (d) {
      return getComputedStyle(d).display !== "none";
    });
  }

  var applied = null;   // colour currently on the tag
  var wanted = null;    // colour the drawer state implies
  var timer = null;

  function sync() {
    var want = anyOpen() ? BRAND : GREY;
    if (want === wanted) return;   // nothing changed
    wanted = want;

    clearTimeout(timer);
    timer = setTimeout(function () {
      if (wanted !== applied) {
        meta.setAttribute("content", wanted);
        applied = wanted;
      }
    }, LEAD_MS);
  }

  if ("MutationObserver" in window) {
    var mo = new MutationObserver(sync);
    drawers.forEach(function (d) {
      mo.observe(d, { attributes: true, attributeFilter: ["style", "class"] });
    });
  }

  // Drawers open from several places - hamburger, cart icon, add-to-cart,
  // click-away, close button. Settle after any interaction rather than binding
  // to each one.
  ["click", "keyup", "pageshow"].forEach(function (evt) {
    window.addEventListener(evt, function () { setTimeout(sync, 0); }, true);
  });

  // Set the initial colour immediately - no delay on first paint.
  wanted = anyOpen() ? BRAND : GREY;
  applied = wanted;
  meta.setAttribute("content", wanted);
})();
